<template>
    <div class="card-container">
        <common-top-form :model="formModel" @openAddDialog="changeInfo()" :submitService="submitService"  addShowPower="/tatwithdraw/add" :submitData="submitData" @success="onSuccess">
                <select-organs v-model="formModel.simpleTatId"></select-organs>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column prop="tatName" label="机构简称" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cost" label="机构费率（元/笔）"  min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.cost)}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="操作时间"  min-width="160"></el-table-column>
            <el-table-column label="操作"  min-width="160">
                <template slot-scope="scope">
                    <el-button type="text" @click="changeInfo(scope.row.id)" v-if="hasPerm('/tatwithdraw/edit')">修改</el-button>
                    <el-button type="text" @click="DeleteInfo(scope.row.id)" class="button-color" v-if="hasPerm('/tatwithdraw/delete')">删除</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel"
                     :dialogService="dialogService" :submitData="dialogData" :rules="dialogRules"
                     @success="dialogSuccess" @close="dialogClose" @opend="dialogOpen" class="note">
            <select-organs v-model="dialogModel.simpleTatId" selectProp="simpleTatId" :selectValue="dialogModel.simpleTatId" :organDisabled="cashId != undefined" :needAll="false" selectWidth="100%"></select-organs>
            <el-form-item label="机构费率" prop="cost">
                <el-input-number :controls="false" placeholder="请输入机构费率" v-model="dialogModel.cost" controls-position="right" :precision="0" :step="1" @change="handleChange" :min="4" :max="9999999" style="width: 78%"></el-input-number>
                <span>元/笔</span>
            </el-form-item>
            <!--<p class="warning-text">机构费率（元/笔）,最小为4.00元</p>-->
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import FormDialog from '../../dialog/FormDialog'

    import OrganService from 'service/OrganService'
    import ChannelService from 'service/ChannelService'
    import ChannelCashService from 'service/ChannelCashService'
    import OrganCashService from 'service/OrganCashService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import SelectOrgans from 'components/business/SelectOrgans'

    export default {
        name: "cardevaluation",
        data(){
            return{
                formModel:{
                    simpleTatId:'',
                },
                submitService:OrganCashService.tatCardTestList,
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                allChnName: [{
                    id: '',
                    chnName: '全部'
                }],
                chnNameList: [],
                topchnNameList: [],
                page:{},
                params:{},
                tableData:[],
                formDialogTitle:'',
                dialogModel: {
                    simpleTatId: '',
                    cost: '0',
                },
                dialogRules:{
                    simpleTatId: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            console.log('value', value)
                            if (!value) {
                                callback(new Error('请选择机构简称'))
                            } else{
                                if (this.getsimpleTatId == value){
                                    return callback();
                                }
                                this.checkOnly(value,res =>{
                                    res.contents.checkFlag ? callback(new Error('机构简称不能重复')) : callback()
                                });
                            }
                        },
                    }],
                    cost: [{
                        required: true,
                        message:'请输入奖励比例'
                    }],
                },
                cashId:'',
                checkFlag:false,
                getsimpleTatId:'',
                isPage:false,
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        components:{
            CommonTopForm, CommonTable, FormDialog, SelectOrgans
        },
        computed:{
            isExist(){
                return this.checkFlag
            },
            submitData(){
                this.params = {
                    simpleTatId: this.formModel.simpleTatId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };
                return this.params;
            },
            dialogService(){
                if (this.cashId) {
                    return OrganCashService.tatCardTestEdit;
                } else {
                    return OrganCashService.tatCardTestAdd;
                }
            },
            dialogData(){
                const params = {
                    userId: this.userId,
                    simpleTatId: this.dialogModel.simpleTatId,
                    cost: this.dialogModel.cost,
                };

                if (this.cashId) {
                    params.id = this.cashId
                }

                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted(){
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        methods:{
            changeInfo(id){
                this.formDialogTitle = id ? '修改' : "添加";
                this.cashId = id;
                this.$refs.formDialog.open();
            },
            getPage(){
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            getDetail() {
                const params = {
                    id: this.cashId,
                };

                this.doLoad(OrganCashService.tatCardTestDetail, params, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.dialogModel = result;
                        this.dialogModel.simpleTatId = result.tatId;
                        this.dialogModel.cost = result.cost * 100 / 10000;
                        this.getsimpleTatId = this.dialogModel.simpleTatId;
                    });
                }, '信息获取失败')
            },
            onSuccess(res){
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                });
            },
            dialogSuccess(res){
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.showSuccess(result.optMsg);
                    this.$refs.formDialog.closeDialog();
                    this.getList();
                });
            },
            dialogClose(){
                this.dialogModel = {
                    simpleTatId: '',
                    cost: '0',
                };
            },
            dialogOpen(){
                if (this.cashId) {
                    this.getDetail();
                }
            },
            handleChange(){},
            doDeleteInfo(id) {
                const disabledParams = {
                    id: id,
                };
                this.doLoad(OrganCashService.tatCardTestDel, disabledParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                }, '操作失败')
            },
            DeleteInfo(id) {
                this.showMsg = '确定删除该数据？'
                this.showConfirm(this.showMsg).then(() => {
                    this.doDeleteInfo(id)
                }).catch(() => {
                });
            },
            checkOnly(val,onSuccess){
                const params = {
                    simpleTatId:val,
                };
                this.doLoad(OrganCashService.tatCardTestCheck,params,res => {
                    this.doCheck(res,res =>{
                        onSuccess && onSuccess(res);
                    });
                },'信息获取失败')
            },
        }

    }
</script>

<style scoped>
    .warning-text{
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        margin-top: -20px;
        padding-left: 90px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/CardEvaluation.vue